'use client';

import React from 'react';
import { StyledCtaBanner } from './AnchorTextAnalyzerTool.styles';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Create content that earns natural anchor text</h2>
        <p>
          CommonNinja has 226+ free widgets: accordions, tabs, comparison tables, feeds, and more.
          Build richer pages that naturally attract descriptive, varied anchor text from internal and external links.
        </p>
        <a className="banner-cta" href="/widgets">Browse all free widgets →</a>
      </div>
    </StyledCtaBanner>
  );
};
